import { Injectable, Injector } from '@angular/core';

import { AbstractDataService } from './abstract-data.service';
import { UserContextService } from './user-context.service';
import { Principal } from '../auth/principal.service';

@Injectable({ providedIn:'root' })
export class UaaResourceService extends AbstractDataService<any> {

    private principal: Principal;
    private userContext: UserContextService;

    constructor( private injector: Injector ) {
        super(injector);
        this.principal = injector.get(Principal);
        this.userContext = injector.get(UserContextService);
    }
    // private getWholeAppTree(): Promise<any> {
    //     const root = this.config.applicationSets.WEB_APPS;
    //     return this.getData(root?root:"web_apps", 'APPLICATION_SET,APPLICATION');
    // }
    getResourceTree(name: string|number, params?:{[key:string]:any}): Promise<any> {
        if(params == null) params = {};
        params.resourceTypes = "APPLICATION_SET,APPLICATION,NAVBAR,NAV";
        params.name = name;
        return this.httpGet(this.apiUrls.getResourceTree, params);
    }

    private getMyData(url:string, name: string|number, params?:{[key:string]:any}): Promise<any>{
        if(params == null) params = {};
        params.name = name;
        
        if(!Object.keys(params).includes('officeId')){
            const currentOffice = this.userContext.currentOffice;
            if(currentOffice) params.officeId = currentOffice.id;
        }

        return this.httpGet(url, params);
    }
    getMyAppTree(name: string|number, params?:{[key:string]:any}): Promise<any> {
        if(name) return this.getMyData(this.apiUrls.myAppTree, name, params);
        else return Promise.resolve(null);
    }
    getMyNavTree(appName: string|number, params?:{[key:string]:any}) : Promise<any>{
        if(params == null) params = {};
        if(params.deep == null) params.deep=true;
        return this.getMyData(this.apiUrls.myNavTree, appName, params);
    }
    getMyAppIds(name: string|number, params?:{[key:string]:any}): Promise<any>{
        // return this.getMyData(this.apiUrls.getMyAppIds, name, params);
        // console.warn("后端需要实现getMyAppIds接口");
        if(name){
            return this.getMyData(this.apiUrls.myAppTree, name, params).then(data=>{
                return this.getAppIds(data);
            });
        }else{
            return Promise.resolve([]);
        }
    }
    private getAppIds(treeNode, ids?:any[]){
        if(ids == null) ids = [];
        if(treeNode != null){
            ids.push(treeNode.id);
            if(treeNode.children){
                treeNode.children.forEach(item => {
                    this.getAppIds(item, ids);
                });
            }
        }
        return ids;
    }
}

